import React from 'react';
import FollowsList from './follows_list';
import { IFollowListActions, IFollowGroup } from '../follow';

const SAVED_SEARCH_CALLOUT_THRESHOLD = 3;

interface IProps {
  groups: IFollowGroup[];
  actions: IFollowListActions;
  enableDigestToggle?: boolean;
}

export default class FollowGroups extends React.Component<IProps, null> {
  propsFor(followGroup, idx) {
    const props = {
      followGroup,
      key: idx,
      actions: this.props.actions,
    };

    if (idx > 0) { return props; }
    return Object.assign(props, { calloutThreshold: SAVED_SEARCH_CALLOUT_THRESHOLD });
  }

  render() {
    if (this.props.groups.length === 0) {
      return (
        <div>
          <FollowsList key="1" />
          <FollowsList key="2" />
        </div>
      );
    }

    return (
      <div>
        {this.props.groups.map((group, idx) => (
          <FollowsList
            {...this.propsFor(group, idx)}
            enableDigestToggle={this.props.enableDigestToggle}
          />
        ))}
      </div>
    );
  }
}
